<template lang="pug">
  v-list.side-drawer
    v-list-group(v-for='item in inventionNavItems', :value='item.active', v-bind:key='item.title')
      v-list-tile(slot='item', @click='')
        v-list-tile-action
          v-icon {{ item.action }}
        v-list-tile-content
          v-list-tile-title {{ item.title }}
        v-list-tile-action
          v-icon keyboard_arrow_down
      v-list-tile(v-for='subItem in item.items', v-bind:key='subItem.title', @click='')
        v-list-tile-content
          v-list-tile-title {{ subItem.title }}
        v-list-tile-action
          v-icon {{ subItem.action }}
</template>

<script>
  export default {
    data () {
      return {
        inventionNavItems: [
          {
            action: 'tonality',
            title: 'Solution',
            active: true,
            items: [
              { title: 'Summary' },
              { title: 'Draw' },
              { title: 'Significance' },
              { title: 'Landscape' },
              { title: 'Keywords' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Problem',
            items: [
              { title: 'Summary' },
              { title: 'Gap' },
              { title: 'Significance' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Construction',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Use',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Development',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Unique Selling Points',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Economics',
            items: [
              { title: 'List Item' }
            ]
          },
          {
            action: 'radio_button_unchecked',
            title: 'Commercialization',
            items: [
              { title: 'List Item' }
            ]
          }
        ]
      }
    }
  }
</script>

<style scoped lang='scss'>
.side-drawer {
  position: fixed;
  top: 100px;
  background-color: red;
  .list__group {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideDrawer.vue